import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, mergeMap, catchError, switchMap } from 'rxjs/operators';
import { Announcements } from '@app/core/async-services/http/versioned/interfaces';
import {
  AnnouncementHttpService,
  ChatHttpService,
} from '@app/core/async-services/http/versioned';
import * as CommunicationActions from './announcement.actions';
import { UrlPreviewService } from '@app/core/services/url-preview/url-preview.service';
import { ChannelData } from '@app/core/async-services/http/versioned/interfaces/chat.interface';

@Injectable()
export class Effects {
  loadAnnouncement = createEffect(() =>
    this._actions.pipe(
      ofType(CommunicationActions.loadExistingAnnouncement),
      mergeMap(({ channelId }) =>
        this._chatHttpService.getChannelData(channelId).pipe(
          switchMap(async (response) => {
            const message = await this._urlPreviewService.addLinkPreviews(
              response.payload!.messages[0],
            );
            return {
              ...response,
              payload: {
                ...response.payload,
                messages: [message, ...response.payload!.messages.slice(1)],
              },
            };
          }),
          map(({ payload }) =>
            CommunicationActions.loadExistingAnnouncementSuccess({
              payload: payload as ChannelData,
            }),
          ),
          catchError((response) =>
            of(CommunicationActions.loadExistingAnnouncementFailure(response)),
          ),
        ),
      ),
    ),
  );

  loadHotels = createEffect(() =>
    this._actions.pipe(
      ofType(CommunicationActions.loadHotels),
      mergeMap(() =>
        this._announcementHttpService.getAnnouncementHotels().pipe(
          map((response) =>
            CommunicationActions.loadHotelsSuccess({ response }),
          ),
          catchError((response: Announcements.HotelsResponse) =>
            of(CommunicationActions.loadHotelsFailure({ response })),
          ),
        ),
      ),
    ),
  );

  loadManagers = createEffect(() =>
    this._actions.pipe(
      ofType(CommunicationActions.loadManagers),
      mergeMap(() =>
        this._announcementHttpService.getAnnouncementManagers().pipe(
          map((response) =>
            CommunicationActions.loadManagersSuccess({ response }),
          ),
          catchError((response: Announcements.ManagersResponse) =>
            of(CommunicationActions.loadManagersFailure({ response })),
          ),
        ),
      ),
    ),
  );

  constructor(
    private _actions: Actions,
    private _announcementHttpService: AnnouncementHttpService,
    private _chatHttpService: ChatHttpService,
    private _urlPreviewService: UrlPreviewService,
  ) {}
}
